export default __webpack_public_path__ + "static/media/twitter.ecaf2e84.svg";